"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fill: "#FF0076",
      d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12Z"
    }), (0, _jsxRuntime.jsx)("path", {
      fill: "#fff",
      d: "M11.502 16.332c-1.344 0-2.1-.252-2.688-.564V14.04h1.044c.264.204.732.372 1.356.372.636 0 1.116-.252 1.116-.78s-.324-.768-1.056-.768h-.756v-1.728h.684c.744 0 1.092-.276 1.092-.732 0-.444-.324-.708-.9-.708-.564 0-1.032.156-1.32.324h-1.02V8.34c.672-.396 1.62-.672 2.796-.672 1.86 0 3.18.696 3.18 2.244 0 1.128-.6 1.716-1.644 1.968v.048c1.2.168 1.8.792 1.8 1.92.012 1.572-1.38 2.484-3.684 2.484Z"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};